import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Coverage from './Coverage';
import BasicInfo from './BasicInfo';
import Destinations from './Destinations';
import Applicants from './Applicants';
import Review from './Review';
import Payment from './Payment';
import { PURCHASE_STEP } from '../consts';

export const STEP_MAP = {
  [PURCHASE_STEP.COVERAGE]: Coverage,
  [PURCHASE_STEP.BASIC_INFO]: BasicInfo,
  [PURCHASE_STEP.DESTINATIONS]: Destinations,
  [PURCHASE_STEP.APPLICANTS]: Applicants,
  [PURCHASE_STEP.REVIEW]: Review,
  [PURCHASE_STEP.PAYMENT]: Payment
};

const STEPS_WITH_ROUTES = Object.entries(STEP_MAP).map(([path, component]) => {
  return <Route exact key={path} path={`*:step(${path})`} component={component} />;
});

const Routes = () => {
  return <Switch>{STEPS_WITH_ROUTES}</Switch>;
};

export default Routes;
